import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { openModal } from "../../../../../../../../../store/features/modal.js";
import { Button, ButtonGroup } from "@shopify/polaris";
import ResourcePickerButton from "../../../../../../../../common/ResourcePickerButton/ResourcePickerButton.js";
import { OPEN_MODAL_ADD_PRODUCTS_USING_FILTERS } from "../../../../../../../../../constants/modalTypes.js";
import { useAppDispatch } from "../../../../../../../../../hooks/redux.js";
interface AddItemsButtonsProps {
  handleAddProducts: () => void;
  handleAddCollections: () => void;
  initialSelectionIds: any;
  handleRemoveProducts?: () => void;
}

const AddItemsButtons: React.FC<AddItemsButtonsProps> = ({ handleAddProducts, handleAddCollections, initialSelectionIds, handleRemoveProducts }) => {
  const dispatch = useAppDispatch();

  const handleOpenModal = useCallback(() => {
    dispatch(openModal({ modalType: OPEN_MODAL_ADD_PRODUCTS_USING_FILTERS }));
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {/* Left Grouped Buttons */}
      <ButtonGroup>
        <ResourcePickerButton
          resourceType={"Product"}
          onSelection={handleAddProducts}
          primary={true}
          disabled={false}
          isLoading={false}
          plain={false}
          title={false}
          initialSelectionIds={[]}
        />
        <Button
          onClick={handleOpenModal}
        >
          Add product using filters
        </Button>
        <ResourcePickerButton
          resourceType={"Collection"}
          onSelection={handleAddCollections}
          primary={false}
          disabled={false}
          isLoading={false}
          plain={false}
          title={false}
          initialSelectionIds={initialSelectionIds && initialSelectionIds.filter(({ id }) => id.includes('Collection')) || []}
        />
      </ButtonGroup>
      {Boolean(initialSelectionIds.length) && <Button plain={true} onClick={handleRemoveProducts}>
        Delete All
      </Button>}
    </div>
  );
};

export default AddItemsButtons;
